'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./login/login'));
    processInclude(require('./login/togglePassword.js'));
    processInclude(require('./login/mandatoryCheckboxAlert.js'));
    processInclude(require('./components/typingOnlyInput.js'));
});
